import type { TFunction } from "i18next"

/**
 * Formats a time unit value according to locale-specific rules.
 * For Hakha Chin (cnh), the format is "{unit} {number}" (e.g., "tim 3").
 * For all other locales, the format is "{number}{unit}" (e.g., "3h").
 *
 * @param value - The numeric value
 * @param translationKey - The i18n key for the unit (e.g., "date.HOUR_SHORT")
 * @param t - The translation function from i18next
 * @param locale - The current locale (can be null/undefined)
 * @returns Formatted string with correct order for the locale
 */
export const formatTimeUnit = (
  value: number,
  translationKey: string,
  t: TFunction,
  locale: string | null | undefined
): string => {
  const unit = t(translationKey)

  if (locale === "cnh") {
    // For Hakha Chin: unit comes first, then space, then number
    return `${unit} ${value}`
  }

  // For all other locales (including null/undefined): number comes first, then unit (no space)
  return `${value}${unit}`
}
